import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

export const WarehousePages = {
  list: 'ListWarehouse',
  add: 'AddWarehouse',
  edit: 'EditWarehouse',
}

const { t } = i18n.global

const title = t('pages.listWarehouse')
const path = '/warehouses'
const breadcrumb = [{ title, path }]

const warehouseFormComponent = () => import('@/pages/mainPageWithRoute/warehouse/FormWarehouse.vue')

const Add: RouteRecordRaw = {
  path: 'add',
  name: WarehousePages.add,
  component: warehouseFormComponent,
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: WarehousePages.edit,
  component: warehouseFormComponent,
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: WarehousePages.list,
  component: () => import('@/pages/mainPageWithRoute/warehouse/ListWarehousePage.vue'),
  meta: { title, requiresAuth: true },
}

export const Warehouses: RouteRecordRaw = {
  path,
  name: 'Warehouses',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit],
}
